import { render } from "./TranslationModal.vue?vue&type=template&id=cfa8f42e&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"

import "./TranslationModal.vue?vue&type=style&index=0&id=cfa8f42e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa8f42e"]])

export default __exports__